import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
// import { useStripe } from 'components/Stripe/StripeHookProvider';
import { useFirebase } from 'components/Firebase/context';
import useAuthUser from 'components/Session/useAuthUser';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {}
}));

const TestView = () => {
  const classes = useStyles({});
  // /const stripe = useStripe();
  const firebase = useFirebase();
  const authUser = useAuthUser();
  const [sources, setSources] = useState([]);
  const [charges, setCharges] = useState([]);
  useEffect(() => {
    if (authUser) {
      const unsub = firebase.firestore
        .collection('stripe_customers')
        .doc(`${authUser.uid}`)
        .collection('sources')
        .onSnapshot(
          snapshot => {
            let newSources = [];
            snapshot.forEach(doc => newSources.push(doc.data()));
            setSources(newSources);
          },
          () => {
            setSources([]);
          }
        );
      const unsub2 = firebase.firestore
        .collection('stripe_customers')
        .doc(`${authUser.uid}`)
        .collection('charges')
        .onSnapshot(
          snapshot => {
            let newCharges = [];
            snapshot.forEach(doc => newCharges.push(doc.data()));
            setCharges(newCharges);
          },
          () => {
            setCharges([]);
          }
        );

      return () => {
        unsub();
        unsub2();
      };
    }
  }, [authUser]);

  const test = async () => {
    console.log(sources);
  };

  const charge = async () => {
    firebase.firestore
      .collection('stripe_customers')
      .doc(authUser.uid)
      .collection('charges')
      .add({
        source: sources[0].id,
        amount: 10000
      });
  };
  return (
    <div className={classes.root}>
      <Button onClick={() => test()}>test</Button>
      <Button onClick={() => charge()}>charge</Button>
      {charges.map(({ amount, error, outcome, source }, i) => (
        <div key={i}>
          [{amount}] {error && <span>[{error}]</span>}
          {outcome && (
            <span>
              [{outcome.seller_message}] [{source.brand}] [{source.last4}] (exp. {source.exp_month}/{source.exp_year})
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default TestView;
